const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/laminates`,
    saveDiscountTable: `${API_URL}/laminate/save-discount-table`
};

export default apiUrls;
